import Box from "@mui/material/Box";
import React, { useEffect } from "react";
import { ComponentStyles } from "../../models/app";
import { Palette } from "../palette/Palette";
import { Feedback } from "../feedback/Feedback";
import { ReactFlowProvider } from "reactflow";
import "reactflow/dist/style.css";
import ScoreBoard from "../scoreboard/ScoreBoard";
import BlockCanvas from "./BlockCanvas";
import { trackEvent, GA_EVENTS } from "../../utils/analytics";
import { BlockSettingsModal } from "../game/BlockSettingsModal";
import { IntroTour } from "../game/IntroTour";
import { ProblemBriefPanel } from "../problems/ProblemBriefPanel";
import { ActiveProblemAuthGate } from "../auth/ActiveProblemAuthGate";

const styles: ComponentStyles = {
  canvas: {
    // Pinned to the visible viewport (unlike 100vw/100vh, which include the
    // scrollbar and the mobile browser toolbars) so the page never scrolls.
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: "hidden",
    backgroundColor: "#fff",
    backgroundImage: `linear-gradient(#9fc5e8 1.5px, transparent 1.5px), linear-gradient(90deg, #9fc5e8 1.5px, transparent 1.5px), linear-gradient(#cfe2f3 1px, transparent 1px), linear-gradient(90deg, #cfe2f3 1px, transparent 1px)`,
    backgroundPosition: "-1.5px -1.5px, -1.5px -1.5px, -1px -1px, -1px -1px",
    backgroundSize: "100px 100px, 100px 100px, 20px 20px, 20px 20px",
  },
};

export const CANVAS_PAGE_CLASS = "canvas-page";

export const Canvas: React.FC = () => {
  const classes = styles;

  useEffect(() => {
    trackEvent(GA_EVENTS.PAGE_VIEW_APP);
  }, []);

  // Lock document scrolling while the canvas page is mounted (see index.css).
  useEffect(() => {
    document.documentElement.classList.add(CANVAS_PAGE_CLASS);
    return () => {
      document.documentElement.classList.remove(CANVAS_PAGE_CLASS);
    };
  }, []);

  return (
    <ReactFlowProvider>
      <Box data-testid="canvas-root" style={classes.canvas}>
        <ScoreBoard />
        <ProblemBriefPanel />
        <BlockCanvas />
        <Palette />
      </Box>
      <Feedback />
      <BlockSettingsModal />
      <IntroTour />
      <ActiveProblemAuthGate />
    </ReactFlowProvider>
  );
};
